import Link from "next/link"
import Image from "next/image"
import { siteConfig } from "@/config/site"

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer-site mt-auto bg-primary px-6 py-12 text-primary-foreground md:py-14">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="text-center sm:col-span-2 lg:col-span-1 lg:text-left">
            <div className="mb-3 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
              <div className="footer-brand-icon shrink-0">
                <Image
                  src="/logo.png"
                  alt={`${siteConfig.name} logo`}
                  width={48}
                  height={48}
                  className="h-10 w-10 object-contain md:h-12 md:w-12"
                  loading="lazy"
                />
              </div>
              <p className="text-lg font-semibold leading-tight">{siteConfig.name}</p>
            </div>
            <p className="text-sm text-primary-foreground/75">&quot;{siteConfig.slogan}&quot;</p>
          </div>

          <nav aria-label="Энэ вэб сайт" className="flex flex-col gap-2 text-sm">
            <p className="text-xs font-medium uppercase tracking-wide text-primary-foreground/55">
              Энэ сайт
            </p>
            <Link href="/courses">Сургалтын хөтөлбөрүүд</Link>
            <Link href="/#testimonials">Сэтгэгдэл</Link>
            <Link href="/#faq">Түгээмэл асуулт</Link>
            <Link href={siteConfig.links.github} target="_blank" rel="noopener noreferrer">
              Асуудал мэдэгдэх
            </Link>
          </nav>

          <nav
            aria-label="MBG-ийн бусад платформ"
            className="flex flex-col gap-2 text-sm"
          >
            <p className="text-xs font-medium uppercase tracking-wide text-primary-foreground/55">
              Бусад платформ
            </p>
            <Link
              href={siteConfig.links.apply}
              target="_blank"
              rel="noopener noreferrer"
              title="apply.mbg.mn"
            >
              Тэтгэлэг — өргөдөл
            </Link>
            <Link
              href={siteConfig.links.shop}
              target="_blank"
              rel="noopener noreferrer"
              title="shop.mbg.mn"
            >
              Онлайн шоп
            </Link>
            <Link
              href={siteConfig.links.orchuulga}
              target="_blank"
              rel="noopener noreferrer"
              title="orchuulga.mbg.mn"
            >
              Бичиг баримт, орчуулга
            </Link>
          </nav>

          <nav aria-label="Community" className="flex flex-col gap-2 text-sm">
            <p className="text-xs font-medium uppercase tracking-wide text-primary-foreground/55">
              Community
            </p>
            <Link
              href={siteConfig.links.instagramChat}
              target="_blank"
              rel="noopener noreferrer"
            >
              IG Community Chat
            </Link>
          </nav>
        </div>

        <div className="border-t border-primary-foreground/15 pt-8 text-center text-xs text-primary-foreground/65">
          <p>© {year} {siteConfig.name}</p>
          <p className="mt-2 max-w-2xl mx-auto leading-relaxed">{siteConfig.description}</p>
        </div>
      </div>
    </footer>
  )
}
